import { CONTEST_TYPES } from '../data/contestTypes';

export default function parseLessonInputValue(
  contestType,
  isGroupContest,
  testId,
  testGroupId
) {
  if (contestType === CONTEST_TYPES.group || isGroupContest) {
    return testGroupId;
  }
  return testId;
}
